import { ReactNode } from 'react'
import { QueryProvider } from './QueryProvider'
import { ErrorProvider } from './ErrorProvider'
import { AuthProvider } from './AuthProvider'
import { SocketProvider } from './SocketProvider'
import { EmergencyNoticeProvider } from './EmergencyNoticeProvider'

// Provider 합성 - 순서 중요 (외부 → 내부)
export const Providers = ({ children }: { children: ReactNode }) => (
  <ErrorProvider>
    <QueryProvider>
      <EmergencyNoticeProvider>
        <AuthProvider>
          <SocketProvider>
            {children}
          </SocketProvider>
        </AuthProvider>
      </EmergencyNoticeProvider>
    </QueryProvider>
  </ErrorProvider>
)
